<div class="label">{{ facet().name }}</div>
@for (item of facet().items; track item.value) {
  @if (control().controls[item.value]) {
    <procure-input-check
      condensed
      [control]="control().controls[item.value]"
    >
      {{ item.value }} - ({{ item.count }})
    </procure-input-check>
  } @else {
    {{ item.value }}
  }
}
